import React, { useContext } from "react";
import styled from "styled-components";
import { ControlContext } from "../../contexts/ControlContext";

const Main = styled.iframe`
  box-sizing: border-box;
  width: ${(props) => props.width + "px"};
  height: ${(props) => props.height + "px"};
  background-color: #191f2b;
  z-index: -1;
  /* border-radius: 8px; */
  /* box-shadow: 0px 4px 12px -20px rgba(0, 0, 0, 0.2),
    0px 8px 20px 2px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12); */
  border: none;
  overflow: hidden;
  margin: 5px;
  pointer-events: none;
  border: ${({ connected }) => (connected === true ? "2px solid #30c17e" : "")};
  border-radius: 4px;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;
const ChangeButton = styled.div`
  margin: 5px 8px 0 0;
  background: #1f222b;
  color: #8a93a5;
  border: 1px solid #2a2e39;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  &:hover {
    color: #fff;
  }
`;
function Engine() {
  const { selectedEngine, projectId, projectLocked, openProjectSelect } =
    useContext(ControlContext);
  let previewH = 1080 / 1.7;
  let previewW = 1920 / 1.7;

  return (
    <Wrapper>
      {!projectLocked && (
        <ChangeButton
          onClick={openProjectSelect}
          title="Change the graphic project used by the preview"
        >
          Change project
        </ChangeButton>
      )}
      <Main
        width={previewW}
        height={previewH}
        id="PreviewEngine"
        name="preview"
        title="Preview"
        src={`${
          window.ENV?.REACT_APP_ENGINE_URL || process.env.REACT_APP_ENGINE_URL
        }/preview/${selectedEngine}/${projectId}?width=${previewW}&height=${previewH}&command_server=${
          window.ENV?.REACT_APP_COMMAND_SERVER ||
          process.env.REACT_APP_COMMAND_SERVER
        }`}
      ></Main>
    </Wrapper>
  );
}

export default React.memo(Engine);
